import React from 'react';
import styles from './index.module.scss'
import { Container } from 'react-bootstrap';

const VideoSection = (props) => {
  const {compData ,isDesktop} = props;
  const filteredData = compData?.slice(0, 3);
  
  return (
    <>
    {
        isDesktop ? 
        (
            <div className={styles.wrapper}>
                {/* <div className={styles.bgimages}>
                <img src="../images/video_background1.png" alt="" />
                </div> */}
            <Container>
                <h2>Videos <div><a href='/video-gallery'>View all</a></div></h2>
                <div className={styles.blockWrapper}>
                {filteredData.map((item, key) => (
                    <div key={key}>
                        <div className='embed-container'><iframe src={item?.acf?.videosrc} allowFullScreen title={item?.acf?.videotitle}></iframe></div>
                    </div>
                ))}
                </div>
            </Container>
            </div>
        ):
        (
            <>
                <div className={styles.wrapper}>
                <div className={styles.bgimages}>
                {/* <img src="../images/video_background1.png" alt="" /> */}
                </div>
            <Container>
                <h2>Videos</h2>
                <div className={styles.customBlockWrapper}>
                {filteredData.map((item, key) => (
                    <div key={key}>
                        <div className='embed-container'><iframe src={item?.acf?.videosrc} allowFullScreen title={item?.acf?.videotitle}></iframe></div>
                    </div>
                ))}
                </div>
            </Container>
            </div>
            </>
        )
    }
    </>
  );
};

export default VideoSection;
